import 'src/services/support';
import { defineBoot } from '@quasar/app-vite/wrappers';
import { Platform } from 'quasar';
import SimpleNotificationDialog from 'components/notifications/SimpleNotificationDialog.vue';
import { init as cloudinaryInit } from 'src/services/cloudinary';
import { init as fullscreenInit } from 'src/services/fullscreen';
import { init as intercomInit } from 'src/services/intercom';
import localeServiceInit from 'src/services/locale';
import { init as navigationServiceInit } from 'src/services/navigation';
import { setDialog, setHandler } from 'src/services/notification';
import WebNotificationsHandler from 'src/services/notification/WebNotificationsHandler';
import store from 'src/store';

export default defineBoot(async ({ router, urlPath }) => {
  // don't run in iframe, minimal app context
  if (urlPath.startsWith('/frame')) {
    return;
  }

  // Store initializations
  await store().dispatch('map/initRouterHandler', router);
  await store().dispatch('app/watchNavigation', router);
  store().commit('tags/clearTagBeingEdited');

  // Service initializations
  localeServiceInit();
  navigationServiceInit({ router, store: store() });
  cloudinaryInit();
  if (!Platform.is.capacitor) {
    setHandler(WebNotificationsHandler);
  }
  setDialog(SimpleNotificationDialog);
  fullscreenInit();
  intercomInit(store);
});
